import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	EnquiryRecordDTO,
	EnquiryRecordRequest,
	EnquiryRecordSaveDTO,
} from '../DTO/forms-management/enquiryRecord';

export const enquiryRecord = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getEnquiryRecordList: builder.query<
			SuccessResponse<EnquiryRecordDTO[]>,
			string
		>({
			query: (id) => ({
				url: `/web/form/enquiry-record/list/${id}`,
				method: 'GET',
			}),
			providesTags: ['EnquiryRecordList'],
		}),
		enquiryRecordHasDraft: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/enquiry-record/has-draft/${id}`,
				method: 'GET',
			}),
			keepUnusedDataFor: 0,
		}),
		getEnquiryRecordDraft: builder.query<
			SuccessResponse<EnquiryRecordSaveDTO>,
			{ id: string; type: string }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/enquiry-record/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		continueEnquiryRecordDraft: builder.mutation<
			SuccessResponse<EnquiryRecordSaveDTO>,
			{ id: string; type: number }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/enquiry-record/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		createEnquiryRecord: builder.mutation<
			SuccessResponse<any>,
			EnquiryRecordRequest
		>({
			query: (body) => ({
				url: `/web/form/enquiry-record`,
				method: 'POST',
				body,
			}),
		}),
		editEnquiryRecord: builder.mutation<
			SuccessResponse<any>,
			EnquiryRecordRequest
		>({
			query: (body) => ({
				url: `/web/form/enquiry-record/${body.id}`,
				method: 'PUT',
				body,
			}),
		}),
		getEnquiryRecordDetail: builder.query<
			SuccessResponse<EnquiryRecordDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/form/enquiry-record/${id}`,
				method: 'GET',
			}),
		}),
		deleteEnquiryRecord: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/enquiry-record/${id}`,
				method: 'DELETE',
			}),

			invalidatesTags: ['EnquiryRecordList'],
		}),
	}),
});

export const {
	useGetEnquiryRecordListQuery,
	useEnquiryRecordHasDraftQuery,
	useGetEnquiryRecordDraftQuery,
	useCreateEnquiryRecordMutation,
	useContinueEnquiryRecordDraftMutation,
	useEditEnquiryRecordMutation,
	useGetEnquiryRecordDetailQuery,
	useDeleteEnquiryRecordMutation,
} = enquiryRecord;
